import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TopBannerAd from "../components/TopBannerAd"; // ✅ IMPORT THIS
import "../styles/Navbar.css";

const navItems = [
  { label: "Home", path: "/" },
  { label: "Interview Prep", path: "/interview" },
  { label: "Contact", path: "/contact" },
  { label: "Coding", path: "/editor-code" },
];

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  // 🔥 Adsterra Ad Script (320x50 small banner for navbar)
  useEffect(() => {
    const container = document.getElementById("nav-ad-container");

    if (container && !container.hasChildNodes()) {
      const atScript = document.createElement("script");
      atScript.innerHTML = `
        atOptions = {
          'key' : '3742393f660d0d7ec16b3504b828721a',
          'format' : 'iframe',
          'height' : 50,
          'width' : 320
        };
      `;

      const script = document.createElement("script");
      script.src = "https://www.highperformanceformat.com/3742393f660d0d7ec16b3504b828721a/invoke.js";
      script.async = true;

      container.appendChild(atScript);
      container.appendChild(script);
    }
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  return (
    <div className={`nav-outer-container ${scrolled ? "is-scrolled" : ""}`}>
      <nav className="cyber-nav">
        {/* Logo Section */}
        <div className="nav-brand-group" onClick={() => handleNavigate("/")}>
          <div className="brand-logo-hex">
            <img
              src="https://res.cloudinary.com/dyutmmnia/image/upload/v1773155909/Screenshot_2026-03-10_202700_ntxaxj.png"
              alt="Logo"
            />
          </div>
          <h1 className="brand-text">Job<span>Kickstart</span></h1>
        </div>

        {/* Desktop Links */}
        <ul className={`nav-links-list ${menuOpen ? "mobile-active" : ""}`}>
          {navItems.map((item) => (
  <li 
    key={item.path} 
    /* Add a class specifically for the Coding item */
    className={item.label === "Coding" ? "nav-coding-item" : ""}
  >
    <button
      onClick={() => handleNavigate(item.path)}
      className={`nav-item-btn ${location.pathname === item.path ? "active" : ""}`}
    >
      {item.label}
    </button>
  </li>
))}
        </ul>

        {/* Action Buttons */}
        <div className="nav-actions">
          <div id="nav-ad-container"></div>
          
          
          <button 
            className={`cyber-hamburger ${menuOpen ? "is-open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>
      <TopBannerAd />
    </div>
  );
};

export default Navbar;